import channelTracking from 'src/config/services/countlyTracking/feature/channelTracking.js'
import classbookTracking from 'src/config/services/countlyTracking/feature/classbookTracking.js'
import timetableTracking from 'src/config/services/countlyTracking/feature/timetableTracking.js'
import cloudTracking from 'src/config/services/countlyTracking/feature/cloudTracking.js'
import adminTracking from 'src/config/services/countlyTracking/feature/adminTracking.js'
import newsTracking from 'src/config/services/countlyTracking/feature/newsTracking.js'
import calendarTracking from 'src/config/services/countlyTracking/feature/calendarTracking.js'
import notificationsTracking from 'src/config/services/countlyTracking/feature/notificationsTracking.js'
import userSettingsTracking from 'src/config/services/countlyTracking/feature/userSettingsTracking.js'
import appTracking from 'src/config/services/countlyTracking/feature/appTracking.js'
import { EVENT_KEY, TRACKING_ACTION } from 'src/config/tracking/index.js'
import trackingUtils from 'src/config/services/countlyTracking/utils.js'
import aiTracking from 'src/config/services/countlyTracking/feature/aiTracking.js'

const clyTracking = {
  ...channelTracking,
  ...classbookTracking,
  ...timetableTracking,
  ...cloudTracking,
  ...adminTracking,
  ...newsTracking,
  ...calendarTracking,
  ...notificationsTracking,
  ...userSettingsTracking,
  ...appTracking,
  ...aiTracking,

  trackAuth (result = 'SUCCESS') {
    const action = {
      registration: ({ origin }) => trackingUtils.track(EVENT_KEY.AUTH.ACTION, { action: TRACKING_ACTION.REGISTRATION, origin, result }),
      login: ({ origin }) => trackingUtils.track(EVENT_KEY.AUTH.ACTION, { action: TRACKING_ACTION.LOGIN, origin, result }),
      logout: ({ origin }) => trackingUtils.track(EVENT_KEY.AUTH.ACTION, { action: TRACKING_ACTION.LOGOUT, origin, result }),
      switchAccounts: ({ crossSaleSchool, crossSaleFeatures }) => trackingUtils.track(EVENT_KEY.AUTH.ACTION, {
        action: TRACKING_ACTION.SWITCH_ACCOUNTS,
        'cross-sale-school': crossSaleSchool,
        'cross-sale-features': crossSaleFeatures
      })
    }
    return { action }
  },

  trackSurvey (entity = 'news', result = 'SUCCESS', failedReason = null) {
    const action = {
      submit: ({ questionCount }) => trackingUtils.track(EVENT_KEY.SURVEY.ACTION, { action: TRACKING_ACTION.SUBMIT, entity, questionCount })
    }
    const start = {
      close: () => trackingUtils.track(EVENT_KEY.SURVEY.START, { action: TRACKING_ACTION.CLOSE }),
      create: () => trackingUtils.track(EVENT_KEY.SURVEY.START, { action: TRACKING_ACTION.CREATE })
    }
    const end = {
      create: ({ questionCount, trackGlobal = null }) => trackingUtils.trackWithResult(EVENT_KEY.SURVEY.END, { action: TRACKING_ACTION.CREATE, entity, questionCount, result, failedReason, trackGlobal })
    }
    return { action, start, end }
  }
}

export default clyTracking
